export default __webpack_public_path__ + "static/media/linkedIn.3f8a4f18.svg";